import { render, staticRenderFns } from "./nHis.vue?vue&type=template&id=6994cd75"
import script from "./nHis.vue?vue&type=script&lang=js"
export * from "./nHis.vue?vue&type=script&lang=js"
import style0 from "./nHis.vue?vue&type=style&index=0&id=6994cd75&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports